import TestTab from '../../components/TestTab';

const TestPage = () => {
  return <TestTab />;
};

export default TestPage;